/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import MaskedInput from "antd-mask-input";
import {
  Form,
  Input,
  Button,
  Checkbox,
  DatePicker,
  Select,
  Divider,
  Space,
  Tooltip,
  Row,
  Col,
} from "antd";
import { MinusCircleOutlined, PlusCircleFilled } from "@ant-design/icons";
import { useSelector, RootStateOrAny } from "react-redux";
import { PhoneType } from "../../lib/interfaces/PhoneType";
import "./AccountCreateIndividual.less";
import usePhoneMask from "../../lib/hooks/usePhoneMask";
import { displayFormat } from "../../lib/utils/formatDate";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 8,
  },
};

const formItemLayoutWithOutLabel = {
  wrapperCol: {
    span: 8,
    offset: 4,
  },
};

type CreateAccountProps = {
  params: any;
  callback: any;
};

interface IAccountCreate {
  createIndividualAccount: (props: CreateAccountProps) => void;
  isCreateInProcess: boolean;
}

function AccountCreateIndividual(props: IAccountCreate) {
  const { createIndividualAccount, isCreateInProcess } = props;
  const { accountStatuses, countries, regions, docTypes, accountTypes } = useSelector(
    (state: RootStateOrAny) => state.dicts
  );
  const phoneTypes: PhoneType[] = useSelector((state: RootStateOrAny) => state.dicts.phoneTypes);
  const [form] = Form.useForm();
  const [isSame, setIsSame] = useState(true);

  const { phoneMask, cleanStringNumber } = usePhoneMask();

  const initialValues = {
    createDate: undefined,
    status: undefined,
    exiteId: [""],
    email: [""],
    phones: [{ countryCode: "", phone: "", phoneTypeId: 1 }],
    country: undefined,
    index: undefined,
    region: undefined,
    district: undefined,
    city: undefined,
    village: undefined,
    street: undefined,
    house: undefined,
    building: undefined,
    apartment: undefined,
    unstructuredAddress: undefined,
    isSame: true,
    actualCountry: undefined,
    actualIndex: undefined,
    actualRegion: undefined,
    actualDistrict: undefined,
    actualCity: undefined,
    actualVillage: undefined,
    actualStreet: undefined,
    actualHouse: undefined,
    actualBuilding: undefined,
    actualApartment: undefined,
    actualUnstructuredAddress: undefined,
    fromDate: undefined,
    toDate: undefined,
    sex: undefined,
    firstName: undefined,
    middleName: undefined,
    lastName: undefined,
    birthDate: undefined,
    birthPlace: undefined,
    docTypeId: undefined,
    docNum: undefined,
    seriesNum: undefined,
    issueEntity: undefined,
    issueCountry: undefined,
    issueDate: undefined,
    accTypeId: 1,
  };

  const onFinish = (values) => {
    const phones = values.phones.map((phoneItem) => ({
      ...phoneItem,
      phone: cleanStringNumber(phoneItem.phone),
      countryCode: cleanStringNumber(phoneItem.countryCode),
    }));

    const params = { ...values, phones };
    if (phones.length === 1 && !phones[0].phone) {
      delete params.phones;
    }

    createIndividualAccount({ params, callback: form.resetFields });
  };

  const fieldsNamesIdentityDocuments = [
    "docTypeId",
    "issueCountry",
    "docNum",
    "issueEntity",
    "seriesNum",
    "issueDate",
  ];

  const getIdentityDocumentsIsRequired = ({ getFieldsValue }) => {
    const allData = getFieldsValue();

    const formatData = fieldsNamesIdentityDocuments.map((fieldName) => [
      fieldName,
      allData[fieldName],
    ]);

    const filteredDataSameValue = formatData.filter(
      (value) => value[1] !== undefined && value[1] !== "" && value[1] !== null
    );

    const filteredDataNotSameValue = formatData.filter(
      (value) => value[1] === undefined || value[1] === "" || value[1] === null
    );

    form.validateFields(filteredDataNotSameValue.map((value) => value[0]));

    if (filteredDataSameValue.length > 0) return true;

    return false;
  };

  const fieldsNamesAddress = [
    "country",
    "index",
    "region",
    "district",
    "city",
    "village",
    "street",
    "house",
    "building",
    "apartment",
    "unstructuredAddress",
  ];

  const getAdressIsRequired = ({ getFieldsValue }) => {
    const allData = getFieldsValue();

    const formatData = fieldsNamesAddress.map((fieldName) => [fieldName, allData[fieldName]]);

    const filteredDataSameValue = formatData.filter(
      (value) => value[1] !== undefined && value[1] !== "" && value[1] !== null
    );

    const filteredDataNotSameValue = formatData.filter(
      (value) => value[1] === undefined || value[1] === "" || value[1] === null
    );

    form.validateFields(filteredDataNotSameValue.map((value) => value[0]));

    if (filteredDataSameValue.length > 0) return true;

    return false;
  };

  const fieldsNamesAddressSame = [
    "actualCountry",
    "actualIndex",
    "actualRegion",
    "actualDistrict",
    "actualCity",
    "actualVillage",
    "actualStreet",
    "actualHouse",
    "actualBuilding",
    "actualApartment",
    "actualUnstructuredAddress",
  ];

  const getAdressSameIsRequired = ({ getFieldsValue }) => {
    const allData = getFieldsValue();

    const formatData = fieldsNamesAddressSame.map((fieldName) => [fieldName, allData[fieldName]]);

    const filteredDataSameValue = formatData.filter(
      (value) => value[1] !== undefined && value[1] !== "" && value[1] !== null
    );

    const filteredDataNotSameValue = formatData.filter(
      (value) => value[1] === undefined || value[1] === "" || value[1] === null
    );

    form.validateFields(filteredDataNotSameValue.map((value) => value[0]));

    if (filteredDataSameValue.length > 0) return true;

    return false;
  };

  return (
    <div className="account-create">
      <h1>Создание аккаунта физического лица</h1>
      <Divider />
      <Form
        form={form}
        labelCol={formItemLayout.labelCol}
        wrapperCol={formItemLayout.wrapperCol}
        labelAlign="left"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        <Form.Item
          label="Дата создания"
          name="createDate"
          rules={[
            {
              required: true,
            },
          ]}
          className="form-item-required__hidden-error"
        >
          <DatePicker format={displayFormat} />
        </Form.Item>
        <Divider />
        <h3>Статус</h3>
        <Form.Item
          label="Cтатус"
          name="status"
          rules={[
            {
              required: true,
            },
          ]}
          className="form-item-required__hidden-error"
        >
          <Select>
            {accountStatuses.map((status) => (
              <Option key={status.id} value={status.id}>
                {status.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <h3>Тип аккаунта</h3>
        <Form.Item
          label="Тип аккаунта"
          name="accTypeId"
          rules={[
            {
              required: true,
            },
          ]}
          className="form-item-required__hidden-error"
        >
          <Select>
            {accountTypes.map((type) => (
              <Option key={type.id} value={type.id}>
                {type.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Divider />
        <Form.List name="exiteId">
          {(fields, { add, remove }, { errors }) => (
            <>
              <Space className="list-title">
                <h3 className="list-title__element">Технический ID</h3>
                <Form.Item className="list-title__element">
                  <Tooltip title="Добавить Технический ID">
                    <PlusCircleFilled className="plus-icon" onClick={() => add()} />
                  </Tooltip>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </Space>
              {fields.map((field, index) => (
                <Form.Item
                  {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                  label={index === 0 ? "Технический ID" : ""}
                  required={false}
                  key={field.key}
                >
                  <Form.Item
                    {...field}
                    validateTrigger={["onChange", "onBlur"]}
                    rules={[
                      {
                        required: false,
                        whitespace: true,
                      },
                    ]}
                    noStyle
                  >
                    <Input className="input-with-icon" />
                  </Form.Item>
                  {fields.length > 1 ? (
                    <MinusCircleOutlined
                      className="dynamic-delete-button minus-icon"
                      onClick={() => remove(field.name)}
                    />
                  ) : null}
                </Form.Item>
              ))}
            </>
          )}
        </Form.List>

        <Divider />

        <h3>Личные данные</h3>
        <Form.Item label="Фамилия" name="lastName" className="form-item-required__hidden-error">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Имя" name="firstName" className="form-item-required__hidden-error">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Отчество" name="middleName">
          <Input allowClear />
        </Form.Item>
        <Form.Item
          label="Дата рождения"
          name="birthDate"
          className="form-item-required__hidden-error"
        >
          <DatePicker format={displayFormat} allowClear />
        </Form.Item>
        <Form.Item label="Пол" name="sex" className="form-item-required__hidden-error">
          <Select allowClear>
            <Option key="m" value="M">
              Мужской
            </Option>
            <Option key="w" value="F">
              Женский
            </Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Место рождения"
          name="birthPlace"
          className="form-item-required__hidden-error"
        >
          <Input allowClear />
        </Form.Item>

        <Divider />

        <h3>Удостоверение личности</h3>
        <Form.Item noStyle dependencies={fieldsNamesIdentityDocuments}>
          {({ getFieldsValue }) => {
            const isRequired = getIdentityDocumentsIsRequired({ getFieldsValue });
            return (
              <Form.Item
                label="Тип документа"
                name="docTypeId"
                className="form-item-required__hidden-error"
                rules={[
                  {
                    required: isRequired,
                  },
                ]}
              >
                <Select allowClear>
                  {[...docTypes]
                    .sort((a, b) => a.id - b.id)
                    .map((doc) => (
                      <Option key={doc.id} value={doc.id}>
                        {doc.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item noStyle dependencies={fieldsNamesIdentityDocuments}>
          {({ getFieldsValue }) => {
            const isRequired = getIdentityDocumentsIsRequired({ getFieldsValue });
            return (
              <Form.Item
                label="Страна выдачи"
                name="issueCountry"
                className="form-item-required__hidden-error"
                rules={[
                  {
                    required: isRequired,
                  },
                ]}
              >
                <Select allowClear>
                  {countries.map((country) => (
                    <Option key={country.id} value={country.id}>
                      {country.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item label="Серия" name="seriesNum">
          <Input allowClear />
        </Form.Item>
        <Form.Item noStyle dependencies={fieldsNamesIdentityDocuments}>
          {({ getFieldsValue }) => {
            const isRequired = getIdentityDocumentsIsRequired({ getFieldsValue });
            return (
              <Form.Item
                label="Номер"
                name="docNum"
                className="form-item-required__hidden-error"
                rules={[
                  {
                    required: isRequired,
                  },
                ]}
              >
                <Input allowClear />
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item noStyle dependencies={fieldsNamesIdentityDocuments}>
          {({ getFieldsValue }) => {
            const isRequired = getIdentityDocumentsIsRequired({ getFieldsValue });
            return (
              <Form.Item
                label="Кем выдано"
                name="issueEntity"
                className="form-item-required__hidden-error"
                rules={[
                  {
                    required: isRequired,
                  },
                ]}
              >
                <Input allowClear />
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item noStyle dependencies={fieldsNamesIdentityDocuments}>
          {({ getFieldsValue }) => {
            const isRequired = getIdentityDocumentsIsRequired({ getFieldsValue });
            return (
              <Form.Item
                label="Дата выдачи"
                name="issueDate"
                className="form-item-required__hidden-error"
                rules={[
                  {
                    required: isRequired,
                  },
                ]}
              >
                <DatePicker format={displayFormat} allowClear />
              </Form.Item>
            );
          }}
        </Form.Item>

        <Divider />

        <Form.List name="phones">
          {(fields, { add, remove }) => {
            const getTitle = (title, index) =>
              index === 0 ? (
                <div
                  style={{
                    fontSize: "13px",
                    margin: "3px 0 5px 0",
                    color: "rgba(0, 0, 0, 0.85)",
                  }}
                >
                  {title}
                </div>
              ) : null;
            return (
              <Row style={{ display: "flex", alignItems: "top" }}>
                <Col span={4} style={{ display: "flex" }}>
                  <h3>Контактный телефон</h3>
                  <Tooltip title="Добавить контактный телефон">
                    <PlusCircleFilled
                      className="plus-icon"
                      style={{ margin: "6px 0 0 8px" }}
                      onClick={() => add({ phoneTypeId: 1 })}
                    />
                  </Tooltip>
                </Col>
                <Col span={20}>
                  {fields.map(({ name, key, ...field }, index) => {
                    return (
                      <Form.Item key={key} wrapperCol={{ span: 24 }}>
                        <Row>
                          <Col span={2}>
                            {getTitle("Код страны", index)}
                            <Form.Item
                              {...field}
                              name={[name, "countryCode"]}
                              className="form-item-required__hidden-error__mb0"
                            >
                              <MaskedInput mask={phoneMask.country} name="countryCode" allowClear />
                            </Form.Item>
                          </Col>
                          <Col span={5} style={{ marginLeft: "10px" }}>
                            {getTitle("Номер", index)}
                            <Form.Item
                              {...field}
                              name={[name, "phone"]}
                              className="form-item-required__hidden-error__mb0"
                            >
                              <MaskedInput mask={phoneMask.phone} name="phone" allowClear />
                            </Form.Item>
                          </Col>
                          <Col span={4} style={{ marginLeft: "10px" }}>
                            {getTitle("Тип номера", index)}
                            <Form.Item
                              {...field}
                              name={[name, "phoneTypeId"]}
                              className="form-item-required__hidden-error__mb0"
                            >
                              <Select>
                                {phoneTypes.map((phoneType) => (
                                  <Select.Option value={phoneType.id} key={phoneType.id}>
                                    {phoneType.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={1}>
                            {fields.length > 1 && (
                              <MinusCircleOutlined
                                className="dynamic-delete-button minus-icon"
                                style={{
                                  marginTop: index === 0 ? "38px" : "10px",
                                  marginLeft: "5px",
                                }}
                                onClick={() => remove(name)}
                              />
                            )}
                          </Col>
                        </Row>
                      </Form.Item>
                    );
                  })}
                </Col>
              </Row>
            );
          }}
        </Form.List>

        <Divider />

        <Form.List name="email">
          {(fields, { add, remove }, { errors }) => (
            <>
              <Space className="list-title">
                <h3 className="list-title__element">Электронная почта</h3>
                <Form.Item className="list-title__element">
                  <Tooltip title="Добавить электронную почту">
                    <PlusCircleFilled className="plus-icon" onClick={() => add()} />
                  </Tooltip>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </Space>
              {fields.map((field, index) => (
                <Form.Item
                  {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                  label={index === 0 ? "Электронная почта" : ""}
                  key={field.key}
                >
                  <Form.Item
                    {...field}
                    rules={[
                      {
                        whitespace: true,
                        type: "email",
                        message: "Электронная почта введена некорректно",
                      },
                    ]}
                    noStyle
                  >
                    <Input className="input-with-icon" />
                  </Form.Item>
                  {fields.length > 1 ? (
                    <MinusCircleOutlined
                      className="dynamic-delete-button minus-icon"
                      onClick={() => remove(field.name)}
                    />
                  ) : null}
                </Form.Item>
              ))}
            </>
          )}
        </Form.List>

        <Divider />

        <h3>Адрес регистрации</h3>
        <Form.Item noStyle dependencies={fieldsNamesAddress}>
          {({ getFieldsValue }) => {
            const isRequired = getAdressIsRequired({ getFieldsValue });
            return (
              <Form.Item
                label="Страна"
                name="country"
                rules={[{ required: isRequired }]}
                className="form-item-required__hidden-error"
              >
                <Select allowClear>
                  {countries.map((country) => (
                    <Option key={country.id} value={country.id}>
                      {country.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item
          label="Индекс"
          name="index"
          rules={[{ max: 10, message: "Максимум 10 символов" }]}
        >
          <Input allowClear />
        </Form.Item>
        <Form.Item noStyle dependencies={fieldsNamesAddress}>
          {({ getFieldsValue }) => {
            const isRequired = getAdressIsRequired({ getFieldsValue });
            return (
              <Form.Item
                label="Регион"
                name="region"
                rules={[
                  {
                    required: isRequired,
                  },
                ]}
                className="form-item-required__hidden-error"
              >
                <Select allowClear>
                  {regions.map((region) => (
                    <Option key={region.id} value={region.id}>
                      {region.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item label="Район" name="district">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Город" name="city">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Населенный пункт" name="village">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Улица" name="street">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Дом" name="house">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Корпус" name="building">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Офис" name="apartment">
          <Input allowClear />
        </Form.Item>
        <Form.Item label="Адрес" name="unstructuredAddress">
          <Input.TextArea allowClear />
        </Form.Item>

        <h3>Фактический адрес</h3>
        <Form.Item name="isSame" valuePropName="checked">
          <Checkbox onChange={() => setIsSame(form.getFieldValue("isSame"))}>
            Совпадает с адресом регистрации
          </Checkbox>
        </Form.Item>

        {isSame || (
          <>
            <Form.Item noStyle dependencies={fieldsNamesAddressSame}>
              {({ getFieldsValue }) => {
                const isRequired = getAdressSameIsRequired({ getFieldsValue });
                return (
                  <Form.Item
                    label="Страна"
                    name="actualCountry"
                    rules={[{ required: isRequired }]}
                    className="form-item-required__hidden-error"
                  >
                    <Select allowClear>
                      {countries.map((country) => (
                        <Option key={country.id} value={country.id}>
                          {country.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                );
              }}
            </Form.Item>
            <Form.Item
              label="Индекс"
              name="actualIndex"
              rules={[{ max: 10, message: "Максимум 10 символов" }]}
            >
              <Input allowClear />
            </Form.Item>
            <Form.Item noStyle dependencies={fieldsNamesAddressSame}>
              {({ getFieldsValue }) => {
                const isRequired = getAdressSameIsRequired({ getFieldsValue });
                return (
                  <Form.Item
                    label="Регион"
                    name="actualRegion"
                    rules={[
                      {
                        required: isRequired,
                      },
                    ]}
                    className="form-item-required__hidden-error"
                  >
                    <Select allowClear>
                      {regions.map((region) => (
                        <Option key={region.id} value={region.id}>
                          {region.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                );
              }}
            </Form.Item>
            <Form.Item label="Район" name="actualDistrict">
              <Input allowClear />
            </Form.Item>
            <Form.Item label="Город" name="actualCity">
              <Input allowClear />
            </Form.Item>
            <Form.Item label="Населенный пункт" name="actualVillage">
              <Input allowClear />
            </Form.Item>
            <Form.Item label="Улица" name="actualStreet">
              <Input allowClear />
            </Form.Item>
            <Form.Item label="Дом" name="actualHouse">
              <Input allowClear />
            </Form.Item>
            <Form.Item label="Корпус" name="actualBuilding">
              <Input allowClear />
            </Form.Item>
            <Form.Item label="Офис" name="actualApartment">
              <Input allowClear />
            </Form.Item>
            <Form.Item label="Адрес" name="actualUnstructuredAddress">
              <Input.TextArea allowClear />
            </Form.Item>
          </>
        )}

        <Divider />

        <Row justify="center" gutter={20}>
          <Col>
            <Form.Item>
              <Link to="/accounts/individual">
                <Button>Отмена</Button>
              </Link>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isCreateInProcess}>
                Создать
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default AccountCreateIndividual;
